import React from 'react';

import TrackingContext from './TrackingContext';
import useTracking from './useTracking';

const TrackableFeature = ({ children, ...props }) => {
  const { trackingContext: parentContext } = useTracking();

  return (
    <TrackingContext.Provider
      value={{
        ...parentContext,
        ...props,
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
};

export default TrackableFeature;
